/*
https://www.facebook.com/
https://www.instagram.com/?hl=en
https://twitter.com/?lang=en

* Copyright (c) 2021. by N-Ach (Pvt) Ltd
*
* ╔═╗ ╔╗    ╔═══╗  ╔╗
* ║║╚╗║║    ║╔═╗║  ║║
* ║╔╗╚╝║    ║║ ║╠══╣╚═╗
* ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
* ║║ ║║║╚══╝║╔═╗║╚═╣║║║
* ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
*
* All rights reserved.
*
* This software is the confidential and proprietary information
* of N-Ach (Pvt) Ltd. ("Confidential Information"). You
* shall not disclose such Confidential Information and shall use
* it only in accordance with the terms of the license agreement
* you entered into with N-Ach (Pvt) Ltd.
*
*
* @Author Shalani Chethana
* @Date 24/01/2025
*/

import React from 'react'
import Styles from "./Footer.module.css";
import { Facebook, YouTube, WhatsApp, LinkedIn } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo.jpg';
import { Container, Grid, Typography } from "@mui/material";
import footerMapImg from '../../assets/images/clientMap.png';



export default function Footer3() {
  return (
    <div>
      {/* <Container > */}
      <Grid container spacing={2} className={Styles.footerGridContainer}>
        <Grid item xs={12} md={4} className={Styles.footerLogoSection}
          sx={{
            width: { xs: '100%', md: 'auto' }
          }}
        >
          <Link href="/">
            <img className={Styles.logo} src={logo} />
          </Link>
          <Typography className={Styles.description}>Technology partner of your Need for ACHievement</Typography>
          <div className={Styles.footerBelowLinks}>
            <p className={Styles.footerFollower}>Follower:</p>
            <a href="https://www.facebook.com/N.ACH.SOFTWARE.SOLUTIONS?mibextid=ZbWKwL" target="_blank" rel="noopener noreferrer">
              <Facebook className={Styles.icon} />
            </a>
            <a href="https://wa.me/message/UHGTQWD3YKATD1" target="_blank">
              <WhatsApp className={Styles.icon} />
            </a>
            <a href="https://www.linkedin.com/company/n-ach/" target="_blank" rel="noopener noreferrer">
              <LinkedIn className={Styles.icon} />
            </a>
          </div>
        </Grid>
        <Grid item xs={3} md={1} className={Styles.footerSection}>
          <Typography className={Styles.footerHeading}>Products</Typography>
          <a href="/ecom">
            <Typography className={Styles.footerLinks}>E-com</Typography>
          </a>
          <a href="/eservice">
            <Typography className={Styles.footerLinks}>E-Services</Typography>
          </a>
          <a href="/ims">
            <Typography className={Styles.footerLinks}>IWMS</Typography>
          </a>
          <a href="/stock">
            <Typography className={Styles.footerLinks}>IMS</Typography>
          </a>
          <a href="/pos">
            <Typography className={Styles.footerLinks}>POS</Typography>
          </a>

        </Grid>
        <Grid item xs={3} md={2} className={Styles.footerSection}>
          <Typography className={Styles.footerHeading}>Services</Typography>
          <a href="#">
            <Typography className={Styles.footerLinks}>Supporting Your Growth</Typography>
          </a>
          <a href="#">
            <Typography className={Styles.footerLinks}>Business Process Management (BPM)</Typography>
          </a>
          <a href="#">
            <Typography className={Styles.footerLinks}>Web Designing</Typography>
          </a>
          <a href="#">
            <Typography className={Styles.footerLinks}>Tailor-made software solutions</Typography>
          </a>

        </Grid>
        <Grid item xs={2} md={1} className={Styles.footerSection}>
          <Typography className={Styles.footerHeading}>Company</Typography>
          <a href="/">
            <Typography className={Styles.footerLinks}>Home</Typography>
          </a>
          <a href="/aboutUs">
            <Typography className={Styles.footerLinks}>About Us</Typography>
          </a>

          <a href="/contact">
            <Typography className={Styles.footerLinks}>Contact Us</Typography>
          </a>
        </Grid>

        <Grid item xs={2} md={3} className={Styles.footerSection}>
          <img src={footerMapImg} className={Styles.footerMapImgComp}></img>
        </Grid>

        <Grid className={Styles.footerMobileSection}>
          <Grid item xs={2} md={2} className={Styles.footerSectionMobile}>
            <Typography className={Styles.footerHeading}>Products</Typography>
            <a href="/ecom">
              <Typography className={Styles.footerLinks}>E-com</Typography>
            </a>
            <a href="/eservice">
              <Typography className={Styles.footerLinks}>E-Services</Typography>
            </a>
            <a href="/ims">
              <Typography className={Styles.footerLinks}>IWMS</Typography>
            </a>
            <a href="/stock">
              <Typography className={Styles.footerLinks}>IMS</Typography>
            </a>
            <a href="/pos">
              <Typography className={Styles.footerLinks}>POS</Typography>
            </a>
          </Grid>

          <Grid item xs={2} md={1} className={Styles.footerSection}>
            <Typography className={Styles.footerHeading}>Services</Typography>
            <a href="#">
              <Typography className={Styles.footerLinks}>Supporting Your Growth</Typography>
            </a>
            <a href="#">
              <Typography className={Styles.footerLinks}>Business Process Management (BPM)</Typography>
            </a>
            <a href="#">
              <Typography className={Styles.footerLinks}>Web Designing</Typography>
            </a>
            <a href="#">
              <Typography className={Styles.footerLinks}>Tailor-made software solutions</Typography>
            </a>

          </Grid>

          <Grid item xs={2} md={1} className={Styles.footerSectionMobileCompany}>
            <Typography className={Styles.footerHeading}>Company</Typography>
            <a href="/">
              <Typography className={Styles.footerLinks}>Home</Typography>
            </a>
            <a href="/aboutUs">
              <Typography className={Styles.footerLinks}>About Us</Typography>
            </a>

            <a href="/contact">
              <Typography className={Styles.footerLinks}>Contact Us</Typography>
            </a>
          </Grid>


        </Grid>
        <Grid item xs={10} md={10} className={Styles.footerMobileSectionMap}>
          <img src={footerMapImg} className={Styles.footerMapImgComp}></img>
        </Grid>
      </Grid>


      {/*

      <div className={Styles.footerBelow}>
        <div className={Styles.footerCopyright}>
          <a href='/terms'><Typography>Terms and Conditions</Typography></a>
          <a href='/privacy'><Typography>Privacy</Typography></a>
        </div>
        
      </div> */}
    </div>
  )
}